import React, { useState } from "react";
import {
  Avatar,
  Box,
  Card,
  Chip,
  Grid,
  Typography,
  useTheme,
  Skeleton,
  Grid2,
} from "@mui/material";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useGetClearanceKpiQuery } from "store/slices/apis/keyClearancesDashboardSlice";
import ClearancePopup from "./ClearancePopup";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import ProjectStatusOverviewHead from "components/ProjectStatusOverviewHead";
import { ReactComponent as ArrowIcon } from "assets/PwC_Funct_Icons_ArrowIncrease_Outline_Black_RGB.svg"
import { ReactComponent as ArrowUpIcon } from "assets/PwC_Funct_Icons_ArrowUp_Outline_Black_RGB.svg"
import { ReactComponent as ArrowDownIcon } from "assets/PwC_Funct_Icons_ArrowDown_Outline_Black_RGB.svg"

const KeyClearancesKPI = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const { data, isLoading } = useGetClearanceKpiQuery(projectId);
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const kpiRaw = data?.data || {};

  const lastUpdated = data?.data?.lastUpdated;

  const kpiArr = [
    {
      title: "Total Clearances",
      value: kpiRaw?.totalClearances,
      change: kpiRaw?.totalClearanceGrowth,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Total Clearance",
    },
    {
      title: "Open Clearances",
      value: kpiRaw?.openClearances,
      change: kpiRaw?.openClearanceGrowth,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Open Clearance",
    },
    {
      title: "Due this month",
      value: kpiRaw?.dueThisMonth,
      change: kpiRaw?.dueThisMonthGrowth,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Due this month Clearance",
    },
    {
      title: "Due next month",
      value: kpiRaw?.dueNextMonth,
      change: kpiRaw?.dueNextMonthGrowth,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Due next month Clearance",
    },
  ];

  const kpiData = kpiArr?.map((item) => {
    const changeValue = item.change;
    const arrow = changeValue >= 0 ? "up" : "down";
    const isPositive = changeValue > 0 ? true : false;
    const absoluteChange = isNaN(changeValue)
      ? "-"
      : changeValue === -100
        ? "0%"
        : `${Math.abs(changeValue)}%`;
    const redColor = "#CE412D";
    return {
      ...item,
      arrow,
      absoluteChange,
      isPositive,
      redColor,
    };
  });

  return (
    <Box>
      <Grid2 container spacing={5} sx={{ mt: "20px" }}>
        <ProjectStatusOverviewHead
          lastModified={lastUpdated}
          marginBottm={"30px"}
        />
      </Grid2>

      <Grid container spacing={2}>
        {(isLoading ? Array(4).fill({}) : kpiData).map((card, index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card
              sx={{
                boxShadow: "none",
                border: "1px solid #25252517",
                borderRadius: "3px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center">
                  {isLoading ? (
                    <Skeleton
                      variant="rectangular"
                      width={40}
                      height={40}
                      sx={{ mr: 2 }}
                    />
                  ) : (
                    <Box
                      sx={{ bgcolor: card.color, width: 40, height: 40, mr: 2 }}
                    />
                  )}

                  <Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      {isLoading ? (
                        <>
                          <Skeleton variant="text" width={60} height={24} />
                          <Skeleton variant="text" width={50} height={20} />
                        </>
                      ) : (
                        <>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {card.value}
                          </Typography>
                          <Chip
                            label={card.absoluteChange}
                            size="small"
                            sx={{
                              backgroundColor: "#E6F4EA",
                              color: card?.isPositive
                                ? card?.redColor
                                : card.changeColor,
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                            icon={
                              card?.absoluteChange !== "0%" &&
                              // (card.arrow === "up" ? (
                              //   <ArrowUpward
                              //     sx={{
                              //       fontSize: "12px !important",
                              //       color: !card.isPositive
                              //         ? `${card.changeColor} !important`
                              //         : `${card?.redColor} !important`,
                              //     }}
                              //   />
                              // ) : (
                              //   <ArrowDownward
                              //     sx={{
                              //       fontSize: "12px !important",
                              //       color: !card.isPositive
                              //         ? `${card.changeColor} !important`
                              //         : `${card.redColor} !important`,
                              //     }}
                              //   />
                              // ))
                              (
                                card.arrow === "up" ? (
                                  <ArrowUpIcon
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      fill: !card.isPositive ? card.changeColor : card.redColor,
                                    }}
                                  />
                                ) : (
                                  <ArrowDownIcon
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      fill: !card.isPositive ? card.changeColor : card.redColor,
                                    }}
                                  />
                                )
                              )

                            }
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ ml: "2px", whiteSpace: "nowrap" }}
                          >
                            this month
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#252525", fontWeight: 500, mt: 0.5 }}
                    >
                      {isLoading ? (
                        <Skeleton width={100} height={20} />
                      ) : (
                        card.title
                      )}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  {isLoading ? (
                    <Skeleton variant="circular" width={37} height={37} />
                  ) : (
                    <Avatar
                      sx={{
                        bgcolor: "#fff",
                        width: 37,
                        height: 37,
                        border: "1px solid #d3d3d3",
                      }}
                    >
                      {/* <MdOutlineArrowOutward
                                             style={{
                                               color: "#252525",
                                               fontSize: "20px",
                                               cursor: "pointer",
                                              
                                             }}
                                             onClick={() => {
                                               setPopupData(card);
                                               setOpen(true);
                                             }}
                                           /> */}
                      <ArrowIcon
                        style={{
                          color: "#252525",
                          fontSize: "20px",
                          cursor: "pointer",
                          height: "13px",
                          stroke: "#252525",
                          strokeWidth: "6"
                        }}
                        onClick={() => {
                          setPopupData(card);
                          setOpen(true);
                        }}
                      />
                    </Avatar>
                  )}
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {open && (
        <ClearancePopup
          title={popupData?.title}
          value={popupData?.value}
          status={popupData?.status}
          onOpen={open}
          onClose={() => setOpen(false)}
        />
      )}
    </Box>
  );
};

export default KeyClearancesKPI;
